import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import { Provider } from 'react-redux';
import { store } from './Components/Store/store';
import {
  loadVessels,
  setActiveVessel,
  setHeartRate,
  setRadii,
  setBifurcations,
  setLvMyocardiumMass,
  setFFRCalculationStatus,
  setVesselJson,
  setSupplementary,
  setStudyInfo
} from './Components/Store/LoadReducer';
import { customAxios, fileStorage } from './helpers/utils';


const initApp = async () => {
  try {
    const jsonUrl = `/file/json/get`;
    const axiosInstance = customAxios();
    const jsonResponse = await axiosInstance.get(jsonUrl);

    // Process JSON response
    const vesselJSON = jsonResponse.data["vessels"];
    store.dispatch(setFFRCalculationStatus(false));
    store.dispatch(setVesselJson(vesselJSON));
    await fileStorage.saveFile('json', vesselJSON);
    const uploadedVessels = vesselJSON
      .map((item) => item.vessel.toLowerCase())
      .filter((vessel) => ['rca', 'lcx', 'lad'].includes(vessel));
    store.dispatch(loadVessels(uploadedVessels));
    if (uploadedVessels.length) {
      store.dispatch(setActiveVessel(uploadedVessels[0]));
    }

    if (jsonResponse.data["heart_rate"]) { 
      store.dispatch(setHeartRate(jsonResponse.data["heart_rate"]));
    }
    if (jsonResponse.data["myocardium_mass"]) {
      store.dispatch(setLvMyocardiumMass(jsonResponse.data["myocardium_mass"]));
    }
    if (jsonResponse.data["radii"]) {
      store.dispatch(setRadii(jsonResponse.data["radii"]));
    }
    if (jsonResponse.data["bifurcations"]) {
      store.dispatch(setBifurcations(jsonResponse.data["bifurcations"]));
    }
    
    if (jsonResponse.data["study_info"]) {
      store.dispatch(setStudyInfo(jsonResponse.data["study_info"]));
    }

    ["age", "gender", "height", "weight"].forEach(key => {
      if (jsonResponse.data[key]) {
        store.dispatch(setSupplementary({
          name: key,
          value: jsonResponse.data[key],
          modelType: "pinn"
        }));
      }
    });

    // Load images
    axiosInstance.get("/file/images/list").then((response) => {
      if (response.data && Array.isArray(response.data.images)) {
        response.data.images.forEach((image) => {
          axiosInstance.get(`/file/${image}/get`, { responseType: 'arraybuffer' }).then((response) => {
            fileStorage.saveFile(image, response.data);
          });
        });
      }
    });

    return true;
  } catch (error) {
    // TODO: log error
    return false;
  }
};

const renderApp = async () => {
  const isSuccessfullyInitialized = await initApp();
  if (isSuccessfullyInitialized) {
    ReactDOM.render(
      <Provider store={store}>
        <App />
      </Provider>,
      document.getElementById('root')
    );
  } else {
    ReactDOM.render(
      <div className="modal">
        <div className="modal-content">
          <h2>Error</h2>
          <p>Failed to initialize application. Please try again later.</p>
        </div>
      </div>,
      document.getElementById('root')
    );
  }
};

renderApp();
